// queries.js

import { gql } from "@apollo/client";

export const GET_PACKAGES_QUERY = gql`
  query Packages($search: String, $first: Int, $skip: Int) {
    packages(search: $search, first: $first, skip: $skip) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        name
        price
        billingDays
        limitMamps
        limitDailywh
        resetTime
      }
    }
  }
`;
